import { v4 as uuid } from 'uuid';

import type { Message } from './types';

export function makeWelcomeMessage(text: string): Message {
  return {
    id: uuid(),
    sender: 'bot',
    kind: 'text',
    text,
    createdAt: Date.now(),
    hideActions: true,
  };
}

export function isInitialWelcomeOnly(messages: Message[]): boolean {
  return (
    messages.length === 1 &&
    messages[0]?.kind === 'text' &&
    messages[0].sender === 'bot' &&
    messages[0].hideActions === true
  );
}
